import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    state => state.updatePartnerDiscount
)

export const selectIsCreatePartnerDiscountModalOpen = createSelector(
    baseSelector,
    (state) => state.isCreatePartnerDiscountModalOpen
)

export const selectIsUpdatePartnerDiscountModalOpen = createSelector(
    baseSelector,
    (state) => state.isUpdatePartnerDiscountModalOpen
)

export const selectIsDeletePartnerDiscountModalOpen = createSelector(
    baseSelector,
    (state) => state.isDeletePartnerDiscountModalOpen
)

export const selectCurrentDiscount = createSelector(
    baseSelector,
    (state) => state.currentDiscount
)

export const selectOnCreate = createSelector(
    baseSelector,
    (state) => state.onCreate
)

export const selectOnDelete = createSelector(
    baseSelector,
    (state) => state.onDelete
)

export const selectOnUpdate = createSelector(
    baseSelector,
    (state) => state.onUpdate
)
